import {
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  PageRoute,
  ScreenType,
  useParams,
  useUnsavedChanges,
  useValidationErrors
} from "@compass/core";
import { Permission, School, SchoolEditResource, SchoolViewResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { SchoolPageBody } from "./SchoolPageBody";
import { SchoolPageHeader } from "./SchoolPageHeader";

const routeName = "school";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
  screenType: ScreenType = "standard";
}

export const schoolPageRoute: PageRoute<Params> = {
  handle: "School",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const SchoolPage = () => {
    const ROOT_PERMISSION: Permission = Permission.UtilitySchools;
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);
  const [school, setSchool] = useState<School>({} as School);
  const [initSchool, setInitSchool] = useState<School>(school);
  const [viewResource, setViewResource] = useState<SchoolViewResource>({});
  const [editResource, setEditResource] = useState<SchoolEditResource>({});
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [school] });
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);

    ApiService.schools.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  useEffect(() => {
    if (params.crudMode === "edit") {
      ApiService.schools.getEditResource().then((response) => {
        setEditResource(response);
      });
    }
  }, [params.crudMode]);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${schoolPageRoute.getPath({ id: id, crudMode: crudMode, screenType: params.screenType, })}`);

  const fetch = (id: number) => {
    ApiService.schools.get(id).then((response) => {
      setSchool(response);
      setInitSchool(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate, unsavedChanges)}
      maxWidth="md"
      header={
        <SchoolPageHeader
          rootPermission={ROOT_PERMISSION}
          handle={schoolPageRoute.handle}
          crudMode={params.crudMode}
          reroute={reroute}
          fetch={fetch}
          school={school}
          setSchool={setSchool}
          initSchool={initSchool}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
          resetUnsavedChanges={resetUnsavedChanges}
        />
      }
      content={
        <SchoolPageBody
          school={school}
          setSchool={setSchool}
          viewResource={viewResource}
          editResource={editResource}
          crudMode={params.crudMode}
          validationErrors={validationErrors}
        />
      }
    />
  );
};
